import clsx from "clsx";

type EvidenceHistoryTimelineSpacerProps = {
    missing?: boolean;
};

const EvidenceHistoryTimelineSpacer = ({
    missing,
}: EvidenceHistoryTimelineSpacerProps) => {
    return (
        <div className="flex gap-12 h-6">
            <div className="flex flex-col items-center ml-4">
                <div className="w-8" />
                <div
                    className={clsx(
                        "hidden relative sm:block flex-1 w-px bg-transparent border-l",
                        missing
                            ? "top-[2px] border-dashed border-red-40"
                            : "border-surface-dark"
                    )}
                />
            </div>
        </div>
    );
};

export default EvidenceHistoryTimelineSpacer;
